export const SCROLL_VALUE_FOR_BUTTON_VISIBILITY = 500;
export const SCROLL_BUTTON_TRANSITION = 'bottom 300ms ease-in-out';
